import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { addProduct } from "../../redux/product/actions";

export default function ProductInputForm() {
  const dispatch = useDispatch();
  const productNameRef = useRef();
  const imageUrlRef = useRef();
  const categoryRef = useRef();
  const priceRef = useRef();
  const quantityRef = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    let productName = productNameRef.current.value;
    let category = categoryRef.current.value;
    let imageUrl = imageUrlRef.current.value;
    let price = parseInt(priceRef.current.value, 10);
    let quantity = parseInt(quantityRef.current.value, 10);
    dispatch(
      addProduct(productName, category, imageUrl, price, quantity, quantity)
    );
    productNameRef.current.value = "";
    categoryRef.current.value = "";
    imageUrlRef.current.value = "";
    quantityRef.current.value = null;
    priceRef.current.value = null;
  };
  return (
    <>
      <div>
        <div className="formContainer">
          <h4 className="formTitle">Add New Product</h4>
          <form
            className="space-y-4 text-[#534F4F]"
            onSubmit={(e) => handleSubmit(e)}
            id="lws-addProductForm"
          >
            <div className="space-y-2">
              <label htmlFor="lws-inputName">Product Name</label>
              <input
                ref={productNameRef}
                className="addProductInput"
                id="lws-inputName"
                type="text"
                required
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="lws-inputCategory">Category</label>
              <input
                ref={categoryRef}
                className="addProductInput"
                id="lws-inputCategory"
                type="text"
                required
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="lws-inputImage">Image Url</label>
              <input
                ref={imageUrlRef}
                className="addProductInput"
                id="lws-inputImage"
                type="text"
                required
              />
            </div>
            <div className="grid grid-cols-2 gap-8 pb-4">
              <div className="space-y-2">
                <label htmlFor="ws-inputPrice">Price</label>
                <input
                  ref={priceRef}
                  className="addProductInput"
                  type="number"
                  id="lws-inputPrice"
                  required
                />
              </div>
              <div className="space-y-2">
                <label htmlFor="lws-inputQuantity">Quantity</label>
                <input
                  ref={quantityRef}
                  className="addProductInput"
                  type="number"
                  id="lws-inputQuantity"
                  required
                />
              </div>
            </div>
            <button type="submit" id="lws-inputSubmit" className="submit">
              Add Product
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
